import * as e from "react";
const c = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.99,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.687.033c4.891-.295 8.94 1.39 12.144 5.057 3.038 3.93 3.892 8.3 2.56 13.11-1.715 4.94-5.098 8.093-10.146 9.457-5.4 1.073-9.989-.373-13.768-4.338C.144 19.268-.793 14.71.667 9.646 2.5 4.573 6.05 1.442 11.313.252c.467-.072.925-.144 1.374-.219zm3.247 6.555a1.3 1.3 0 01.967.312c2.49 3.584 2.99 7.434 1.499 11.55a12.075 12.075 0 01-1.499 2.684c-.656.48-1.197.376-1.623-.313a1.9 1.9 0 010-.686c2.053-2.905 2.543-6.058 1.467-9.458a11.815 11.815 0 00-1.467-2.778c-.144-.628.075-1.065.656-1.311zM12.687 8.96c.286-.024.556.028.811.156 1.514 1.903 2.044 4.057 1.593 6.462a8.21 8.21 0 01-1.374 3.12c-.426.43-.895.482-1.405.157-.29-.286-.384-.629-.281-1.03 1.707-2.539 1.707-5.077 0-7.616-.115-.6.104-1.017.656-1.249zm-3.06 2.31c.52.025.884.275 1.093.75.815 1.6.68 3.108-.406 4.525-.489.314-.936.262-1.343-.156a1.037 1.037 0 01-.187-.874c.708-.999.708-1.998 0-2.997-.074-.664.207-1.08.843-1.248z",
      fill: "#2D6DED"
    }
  )
), t = c;
export {
  t as default
};
